import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import { APIHandler, StorageHandler, BackVideo, DataHandler, ExhibitionUsers, ContentHeader, TickerItem } from 'C4';
import { storageKeys, bgVideo } from 'settings';
import SweetAlert from 'sweetalert-react';
import { renderToStaticMarkup } from 'react-dom/server';

import darkLogo from 'assets/images/logo/logo_dark.png';

import Ticker from 'react-ticker';

import 'react-toastify/dist/ReactToastify.css';

const WelcomeFloor = () => (
  <div className="access__container">
    <img src={darkLogo} alt="logo" className="logoFancy" />
    <h5>Welcome to the Exhibition Floor!</h5>
    <p>
      Just tap on any icon to enter the booth, discover and chat
    </p>
  </div>
);

export default class ExhibitionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: false,
      post: [],
    };
  }

  componentWillMount() {
    this.popupView();
    this.getPosts();
  }

  popupView() {
    if (!localStorage.getItem('viewedPopup')) {
      localStorage.setItem('viewedPopup', true);
      this.setState({
        popup: true,
      });
    }
  }

  getPosts() {
    // TODO remove hardcode
    const ids = [0, 6, 7];
    APIHandler.getPosts(ids).then((res) => {
      StorageHandler.save(storageKeys.favorites, res);
      this.setState({ posts: res });
    });
  }

  render() {
    const { popup, posts } = this.state;
    const close = () => {
      this.setState({
        popup: false,
      });
      localStorage.setItem('viewedPopup', true);
    };

    return (
      <div className="exhibition">
        {bgVideo && <BackVideo />}
        <div className="gradient" />

        <div className="schedule">
          <h3>Today&apos;s Program</h3>
          <br />
          <Link to="/main/breakout-sessions">
            <h3>Breakout Sessions</h3>
            <Link to="/main/breakout-sessions/class/101">
              <p><b>Road Trippin&apos; - <br />an American Classic</b><br />11:00am - 11:30am</p>
            </Link>
            <Link to="/main/breakout-sessions/class/101">
              <p><b>Travel Insurance Matters</b><br />11:15am - 11:40am</p>
            </Link>
          </Link>
          <Link to="/main/exhibition">
            <h3>Showground News</h3>
          </Link>
          <Link to="/main/exhibition/101">
            <p><b> L.A.&apos;s Corona Proof Travel</b></p>
          </Link>
          <Link to="/main/exhibition/101">
            <p><b>Anaheim Travel Smart</b></p>
          </Link>
          <Link to="/main/network-lounge">
            <h3>Network Lounge</h3>
            <p><b>Live Chat</b><br />1pm - 6:30pm</p>
          </Link>
        </div>

        <ContentHeader
          header="Welcome to the Exhibitor Floor"
          subtitle="Just tap on any icon to enter the booth, discover and chat"
          icon="map-marked-alt"
        />
        <div className="exhibition__container">
          <div className="connector" />
          <div className="connector2" />
          <ExhibitionUsers
            buttonIcon="road"
            buttonLink="/main/breakout-sessions"
            buttonPosition="domestic"
            buttonColor="#cd2d12"
            title="Domestic Destinations"
          />

          <ExhibitionUsers
            buttonIcon="handshake"
            buttonLink="/main/network-lounge"
            buttonPosition="operators"
            buttonColor="#2dac7e"
            title="Tour Operators"
          />

          <ExhibitionUsers
            buttonIcon="hotel"
            buttonLink="/main/prize-center"
            buttonPosition="hotels"
            buttonColor="#980398"
            title="Hotels"
          />

          <ExhibitionUsers
            buttonIcon="camera"
            buttonLink="/main/training-sessions"
            buttonPosition="attractions"
            buttonColor="#109bc7"
            title="Attractions"
          />

          <ExhibitionUsers
            buttonIcon="coins"
            buttonLink="/main/network-lounge"
            buttonPosition="sponsors"
            buttonColor="#2dac7e"
            title="Sponsors"
          />

        </div>

        <SweetAlert
          title=""
          show={popup}
          html
          text={renderToStaticMarkup(<WelcomeFloor close={close} />)}
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        />

        <div style={{ position: 'relative', marginBottom: 0 }}>
          {posts &&
          <Ticker height="40">
            {({ index }) => (
              <React.Fragment>
                {posts.map(post => <TickerItem post={post} />)}
              </React.Fragment>
          )}
          </Ticker>
            }
        </div>
        <style>{'\
        #openWidget { display: none; bottom: 3rem; } '}
        </style>

        <div className="bottom__bar" />
      </div>

    );
  }
}
